import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { ImportedDashboard } from '../components/DashboardImporter';

interface DashboardTabState {
  importedDashboard: ImportedDashboard | null;
  isPreviewMode: boolean;
  hideHeader: boolean;
}

interface DashboardStore {
  dashboards: Record<string, DashboardTabState>;
  setDashboardState: (dashboardId: string, state: Partial<DashboardTabState>) => void;
  resetDashboardState: (dashboardId: string) => void;
  removeDashboard: (dashboardId: string) => void;
}

const defaultTabState: DashboardTabState = {
  importedDashboard: null,
  isPreviewMode: false,
  hideHeader: false,
};

export const useDashboardStore = create<DashboardStore>()(
  persist(
    (set) => ({
      dashboards: {},
      setDashboardState: (dashboardId: string, state: Partial<DashboardTabState>) =>
        set((s: DashboardStore) => ({
          dashboards: {
            ...s.dashboards,
            [dashboardId]: {
              ...defaultTabState,
              ...s.dashboards[dashboardId],
              ...state,
            },
          },
        })),
      resetDashboardState: (dashboardId: string) =>
        set((s: DashboardStore) => ({
          dashboards: {
            ...s.dashboards,
            [dashboardId]: { ...defaultTabState },
          },
        })),
      removeDashboard: (dashboardId: string) =>
        set((s: DashboardStore) => {
          const dashboards = { ...s.dashboards };
          delete dashboards[dashboardId];
          return { dashboards };
        }),
    }),
    {
      name: 'dashboard-store',
    }
  )
);
